/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import Dashboardheader from "./common/Dashboardheader";
import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { forgotPassword } from "../store/actions/forgotPasswordAction";
import { useDispatch } from "react-redux";

function useWindowSize() {
  // const [email, setEmail] = useState('')
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}


const schema = Yup.object().shape({
  email: Yup.string()
    .required("Mot de passe nécessaire")
    .email("Invalid email format"),
});
const forgotpassword = () => {
const dispatch = useDispatch();
const size = useWindowSize();
  return (
    <div
      className="MapContent navbartopmargin bg"
      style={{ minHeight: size.height }}
    >
      <Head>
        <title>Residen | Forgot Password</title>
      </Head>
      <Dashboardheader />
      <div className="container pt-4 pb-4">
        <div className="height d-flex justify-content-center align-items-center">
          <div className="form-main-box">
            <Formik
              validationSchema={schema}
              initialValues={{ email: "" }}
              validate={(values) => {
                const errors = {};
                return errors;
              }}
              onSubmit={(values) => {
                // console.log(values, '++++++');
                const { email } = values;
                dispatch(forgotPassword({ email }));
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                /* and other goodies */
              }) => (
                <form noValidate onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      placeholder="Email ou téléphone"
                      className="form-control inp_text"
                      id="email"
                    />
                    <span className="error text-danger">
                      {/* {errors} */}
                      {errors.email && touched.email && errors.email}
                    </span>
                  </div>
                  <div className="mb-4">
                    <button
                      type="submit"
                      // disabled={isSubmitting}
                      className="def_btn btn frm-btn-cmn"
                    >
                      Reset my password
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default forgotpassword;
